import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Logo } from '../components/icons';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(username.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(
        err.response?.status === 401
          ? 'Identifiants invalides.'
          : "Connexion impossible. Réessaie dans un instant.",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <div className="login__panel">
        <div className="login__brandmark"><Logo width={30} height={30} /></div>
        <h1 className="login__title">SmartMobility</h1>
        <p className="login__sub">Tableau de bord décisionnel — accès administrateur</p>

        <form className="login__form" onSubmit={submit}>
          <label className="login__label">Identifiant</label>
          <input
            className="login__input" type="text" autoComplete="username" autoFocus
            value={username} onChange={(e) => setUsername(e.target.value)}
            placeholder="admin"
          />
          <label className="login__label">Mot de passe</label>
          <div className="login__pwd">
            <input
              className="login__input" type={showPwd ? 'text' : 'password'} autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
            <button
              type="button" className="login__eye"
              onClick={() => setShowPwd((v) => !v)}
              aria-label={showPwd ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            >
              {showPwd ? 'Masquer' : 'Afficher'}
            </button>
          </div>

          {error && <div className="login__error">{error}</div>}

          <button className="login__btn" type="submit" disabled={busy}>
            {busy ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>

        <div className="login__foot">La mobilité intelligente du Sénégal · D4D</div>
      </div>
      <div className="login__aside">
        <div className="login__aside-inner">
          <h2>Centre d'intelligence<br />de la mobilité</h2>
          <p>Flux origine-destination, prévisions, déserts de mobilité, anomalies et simulation — pour Dakar.</p>
        </div>
      </div>
    </div>
  );
}
